/* eslint-disable */
const pre = '/integral/';

export default {
    path: '/integral',
    title: '积分模块',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-dashboard',
    children: [
        {
            path: `${pre}carousel`,
            title: '轮播图管理',
        },
        {
            path: `${pre}goods-cate`,
            title: '商品分类管理',
        },
        {
            path: `${pre}goods`,
            title: '商品管理',
        },
        {
            path: `${pre}order`,
            title: '订单管理',
        },
        // {
        //     path: `${pre}data`,
        //     title: '数据统计',
        // },
        {
            path: `${pre}get-record`,
            title: '积分获取记录',
        },
        {
            path: `${pre}use-record`,
            title: '积分使用记录',
        },
    ],
};
